module.exports = __webpack_public_path__ + "img/shiba-loading.0e80efd6.png";